import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "80px",
  background: "#FCF9F7",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "48px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "56px 16px",
    gap: "24px",
    alignItems: "flex-start",
  },
}));

export const TaglineContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch",
  justifyContent: "center",
  width: "100%",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {
    gap: "24px",
    // maxWidth: "392px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    maxWidth: "none",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "48px",
  fontFamily: "Georgia",
  letterSpacing: "0.06px",
  textAlign: "center",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  maxWidth: "1280px",
  alignItems: "flex-start",
  gap: "80px",
  flexDirection: "row",
  justifyContent: "center",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    gap: "48px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "24px",
  },
}));

export const AccordionStyled = styling(Accordion)((props) => ({
  margin: 0,
  "&.Mui-expanded": {
    margin: 0,
  },
  backgroundColor: "transparent",
  boxShadow: "none",
  borderBottom: "1px solid #AEAEAE",
}));

export const AccordionSummaryStyled = styling(AccordionSummary)((props) => ({
  display: "flex",
  padding: "16px 8px",
  gap: "24px",
  flexDirection: "row-reverse",
  margin: 0,
  "&.Mui-expanded": {
    margin: 0,
    padding: "16px 8px 0px 8px",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(0deg)",
    transition: "transform 0.3s ease, color 0.3s ease",
    color: "#261754",
    fontSize: "48px",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(45deg)",
    color: "#512ACC",
    fontSize: "48px",
  },
}));

export const AccordionDetailsStyled = styling(AccordionDetails)((props) => ({
  padding: "8px 8px 16px 80px",
}));

export const AccordionText = styling(Typography)((props) => ({
  ...(props?.type == "title" && {
    color: props?.expanded ? "#512ACC" : "#261754",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "36px",
  }),

  ...(props?.type == "description" && {
    color: "#261754",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "30px",
    letterSpacing: "0.03px",
  }),

  [props.theme.breakpoints.down("tablet")]: {
    ...(props?.type == "title" && {
      fontSize: "16px",
      lineHeight: "24px",
    }),

    ...(props?.type == "description" && {
      fontSize: "14px",
      lineHeight: "21px",
      letterSpacing: "unset",
    }),
  },
}));

export const TabsStyled = styling(Tabs)((props) => ({
  minWidth: "271px",
  borderColor: "divider",
  borderRight: 0,
  gap: "16px",
  borderLeft: "3px solid #261754",

  "& .MuiTabs-indicator": {
    left: 0,
    right: "auto",
    backgroundColor: "#261754",
    width: "8px",
  },

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "675px",
    margin: "0 auto",
    minWidth: "unset",
    borderLeft: "none",
    borderBottom: "3px solid #261754",
    gap: "0px",
    flexDirection: "row",

    "& .MuiTabs-indicator": {
      left: 0,
      right: "0px",
      height: "8px",
      width: "100px",
    },
  },
  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
    margin: "0px",
  },
}));

export const TabStyled = styling(Tab)((props) => ({
  minWidth: "271px",
  alignItems: "flex-start",
  padding: "16px 24px",
  color: "rgba(0, 0, 0, 0.60)",
  fontSize: "20px",
  fontWeight: 700,
  lineHeight: "30px",
  letterSpacing: "0.03px",
  textTransform: "capitalize",

  "&.Mui-selected": {
    color: "#261754",
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "unset",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.024px",
  },
}));
